import React from 'react';
import { ShoppingBasketIcon, PackageIcon, CheckCircleIcon, MapIcon } from 'lucide-react';
interface BottomNavBarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  basketConfirmed: boolean;
}
const BottomNavBar: React.FC<BottomNavBarProps> = ({
  activeTab,
  setActiveTab,
  basketConfirmed
}) => {
  const tabs = [
    { id: 'basket', label: 'Basket', icon: <ShoppingBasketIcon size={20} />, disabled: false },
    { id: 'today', label: "Today's", icon: <PackageIcon size={20} />, disabled: false },
    { id: 'route', label: 'Route', icon: <MapIcon size={20} />, disabled: false },
    { id: 'completed', label: 'Completed', icon: <CheckCircleIcon size={20} />, disabled: false },
    // { id: 'paused', label: 'Paused', icon: <PauseCircleIcon size={20} />, disabled: true },
  ];
  const handleTabClick = (tabId: string, disabled?: boolean) => {
    if (disabled) return;
    setActiveTab(tabId);
  };
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 w-full bg-white border-t border-amber-200 shadow-lg pb-[max(1rem,env(safe-area-inset-bottom))]">
      <div className="flex justify-around">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`flex flex-col items-center justify-center py-2.5 px-3 w-1/4 min-w-0
              ${activeTab === tab.id ? 'text-orange-600 border-t-2 border-orange-600' : 'text-gray-500'}
              ${tab.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            onClick={() => handleTabClick(tab.id, tab.disabled)}
            disabled={tab.disabled}
          >
            {tab.icon}
            <span className="text-xs mt-1">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};
export default BottomNavBar;